var e = {
	list: {
		title: "Coupons",
		subtitle: "Create and manage discount codes for your guests.",
		createCoupon: "Create Coupon",
		empty: {
			message: "No coupons yet. Create your first discount code for your guests.",
			createFirst: "Create your first coupon"
		},
		card: {
			discountOffStay: "{{discount}} off the nightly stay",
			discountOffStayCapped: "{{discount}} off the nightly stay, up to {{cap}}",
			redemptions: "Redemptions",
			budgetSpent: "Budget spent"
		}
	},
	detail: {
		notFound: "Coupon not found",
		discountOffStay: "{{discount}} off the nightly stay",
		discountOffStayCapped: "{{discount}} off the nightly stay, up to {{cap}}",
		pause: "Pause",
		resume: "Resume",
		moreActions: "More actions",
		edit: "Edit",
		retire: "Retire",
		allListings: "All listings in your workspace.",
		redemptions: "Redemptions",
		toast: {
			paused: "Coupon paused",
			resumed: "Coupon resumed",
			updateFailed: "Could not update coupon",
			retired: "Coupon retired",
			retireFailed: "Could not retire coupon"
		},
		confirmRetire: {
			title: "Retire \"{{code}}\"?",
			description: "This expires the coupon — the code stops redeeming. Existing redemptions are unaffected.",
			confirm: "Retire coupon"
		}
	},
	form: {
		editTitle: "Edit coupon",
		newTitle: "New coupon",
		code: "Code",
		codePlaceholder: "e.g. SUMMER25",
		discountType: "Discount type",
		discountValue: "Discount value",
		discountValuePlaceholder: "e.g. 25",
		limitsHeading: "Limits (leave blank for no limit)",
		startsAt: "Starts at",
		endsAt: "Ends at",
		maxRedemptions: "Max redemptions",
		maxPerGuest: "Max per guest",
		unlimited: "Unlimited",
		maxDiscountPerBooking: "Max discount per booking (EGP)",
		maxDiscountPerBookingHint: "The most one booking can save. Larger discounts are capped at this amount.",
		maxDiscountBudget: "Max discount budget (EGP)",
		maxDiscountBudgetHint: "The total all bookings can save together.",
		status: "Status",
		saveChanges: "Save changes",
		createCoupon: "Create coupon",
		toast: {
			created: "Coupon created",
			updated: "Coupon updated",
			saveFailed: "Failed to save coupon"
		},
		validation: {
			codeRequired: "Code is required",
			percentage: "Enter a percentage between 1 and 100",
			amount: "Enter an amount greater than 0"
		},
		targets: {
			appliesTo: "Applies to",
			allDescription: "All listings in your workspace. Select listings to limit where this coupon can be used.",
			limitedDescription_one: "Limited to {{count}} listing.",
			limitedDescription_other: "Limited to {{count}} listings.",
			removeListing: "Remove {{title}}",
			selectListings: "Select listings"
		},
		picker: {
			title: "Select listings",
			searchPlaceholder: "Search by title, address, city...",
			moreFilters: "More Filters",
			noResults: "No listings found. Try adjusting your search or filters.",
			unitIn: "Unit in {{address}}",
			listing: "Listing",
			beds_one: "{{count}} bed",
			beds_other: "{{count}} beds",
			selectedCount_one: "{{count}} listing selected",
			selectedCount_other: "{{count}} listings selected",
			done: "Done"
		}
	}
};
//#endregion
export { e as default };
